var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48 21 1 30 29 8-28 11 2 30-19-23L5 88l16-26L2 39l29 8 17-26Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m72 16 2 10 9 1-8 4 1 9-7-6-8 4 4-8-6-7 9 2 4-9ZM70 71l2 9h9l-7 5 3 8-7-5-7 5 2-8-7-5h9l3-9ZM11 0l9 10 13-6-7 12 10 10-14-2-7 12-1-14-14-2 13-6-2-14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTokenIcon);
export default __webpack_public_path__ + "static/media/menu-token-icon.f24d7cf797e0a6a784cee157ca3d5712.svg";
export { ForwardRef as ReactComponent };